import { createApp } from 'vue';
import VueLazyload from 'vue-lazyload';
import Toast, { PluginOptions, POSITION } from 'vue-toastification';
import '@/assets/styles/foundation/settings/_toast.scss';
import Vue3TouchEvents from 'vue3-touch-events';
import { COMMON_IMG_URL } from '@/constants/BlackList';
import { registerComponent } from '@/plugins/ComponentRegister';
import { setupGtm, gtmEnabled } from '@/plugins/GtmSetup';
import { sentrySetup } from '@/plugins/SentrySetup';
import App from './App.vue';
import router from './router';
import '@/assets/styles/app.scss';
import '@/plugins/DisableUserScalable';
import '@/plugins/VConsole';

const app = createApp(App);

const toastOptions: PluginOptions = {
  position: POSITION.TOP_CENTER,
  timeout: 2000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  closeButton: 'button',
  icon: false,
  rtl: false,
  transition: 'Vue-Toastification__fade',
  maxToasts: 20,
  newestOnTop: true,
};

app.use(Toast, toastOptions);
app.use(VueLazyload, {
  preLoad: 1.3,
  error: COMMON_IMG_URL,
  loading: COMMON_IMG_URL,
  attempt: 3,
  observer: true,
  observerOptions: {
    rootMargin: '0px',
    threshold: 0.1,
  },
});
app.use(router);
app.use(Vue3TouchEvents);
sentrySetup(app, router);
registerComponent(app);
if (gtmEnabled) app.use(setupGtm(router));

app.mount('#app');
